import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import '../../App.css';

function VerifyDelivery() {
  const [searchParams] = useSearchParams();
  const [result, setResult] = useState(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setResult({ valid: false, error: 'No delivery pass was supplied.' });
      return;
    }
    fetch(`/api/payments/verify-delivery?token=${encodeURIComponent(token)}`)
      .then(async (response) => {
        const data = await response.json();
        setResult(data);
      })
      .catch(() => setResult({ valid: false, error: 'The delivery pass could not be checked.' }));
  }, [searchParams]);

  return (
    <main className='content-page verification-page'>
      <section className={`verification-card ${result && result.valid ? 'valid' : ''}`}>
        {!result && <><span className='payment-spinner' /><p>Verifying delivery pass…</p></>}
        {result && result.valid && (
          <>
            <span className='verification-icon'>✓</span>
            <p className='section-kicker'>Verified paid order</p>
            <h1>Delivery approved</h1>
            <dl>
              <div><dt>Customer</dt><dd>{result.customerName}</dd></div>
              <div><dt>Order</dt><dd>{result.reference}</dd></div>
              <div><dt>Quantity</dt><dd>{result.quantity} bottle(s)</dd></div>
            </dl>
            <p className='verification-note'>Confirm the recipient’s name before handing over this order.</p>
          </>
        )}
        {result && !result.valid && (
          <>
            <span className='verification-icon invalid'>×</span>
            <p className='section-kicker'>Delivery pass rejected</p>
            <h1>Unable to verify</h1>
            <p className='section-copy'>{result.error || 'This order is not confirmed as paid.'}</p>
          </>
        )}
        <Link to='/' className='text-link gold'>Return to Mukwei Gin →</Link>
      </section>
    </main>
  );
}

export default VerifyDelivery;
